export interface IEducationalAid {
  name: string;
  path: string;
  url: string;
}
